export const amenityTypes = [
  { id: "INTERNET", name: "Internet vorhanden" },
  { id: "WIFI", name: "WLAN" },
  { id: "AIR_CONDITIONING", name: "Klimaanlage" },
  { id: "HEATING", name: "Heizung" },
  { id: "FIREPLACE", name: "Kamin" },
  { id: "WASHING_MACHINE_AVAILABLE", name: "Waschmaschine" },
  { id: "DRYER", name: "Trockner" },
  { id: "DISHWASHER", name: "Geschirrspüler" },
  { id: "OVEN", name: "Backofen" },
  { id: "STOVE", name: "Herd" },
  { id: "MICROWAVE", name: "Mikrowelle" },
  { id: "COFFEE_MACHINE", name: "Kaffeemaschine" },
  { id: "KETTLE", name: "Wasserkocher" },
  { id: "TOASTER", name: "Toaster" },
  { id: "FRIDGE", name: "Kühlschrank" },
  { id: "FREEZER", name: "Gefrierschrank" },
  { id: "SATELLITE_CABLE_TV", name: "Satelliten-/Kabel-TV" },
  { id: "SMART_TV", name: "Smart-TV" },
  { id: "DVD_BLU_RAY_PLAYER", name: "DVD/Blu-ray-Player" },
  { id: "STREAMING_SERVICES", name: "Streaming Dienste" },
  { id: "BOARD_GAMES", name: "Brettspiele" },
  { id: "BOOKS", name: "Bücher" },
  { id: "COT", name: "Kinderbett" },
  { id: "HIGH_CHAIR", name: "Hochstuhl" },
  { id: "BED_LINEN_INCLUDED", name: "Bettwäsche inklusive" },
  { id: "TOWELS_INCLUDED", name: "Handtücher inklusive" },
  { id: "HAIR_DRYER", name: "Fön" },
  { id: "IRON_AND_IRONING_BOARD", name: "Bügeleisen und Bügelbrett" },
  { id: "SAFE", name: "Safe" },
  { id: "PARKING", name: "Parkplatz" },
  { id: "GARAGE", name: "Garage" },
  { id: "BIKE_STORAGE", name: "Fahrradabstellraum" },
  { id: "BALCONY", name: "Balkon" },
  { id: "TERRACE", name: "Terrasse" },
  { id: "GARDEN", name: "Garten" },
  { id: "GRILL", name: "Grill" },
  { id: "WHIRLPOOL", name: "Whirlpool" },
  { id: "SAUNA", name: "Sauna" },
  { id: "BATHTUB", name: "Badewanne" },
  { id: "POOL", name: "Pool" },
  { id: "GYM", name: "Fitnessraum" },
  { id: "PLAYGROUND", name: "Spielplatz" },
  { id: "CLOSE_TO_BEACH", name: "Strandnähe" },
  { id: "LAKE_VIEW", name: "Seeblick" },
  { id: "MOUNTAIN_VIEW", name: "Bergblick" },
  { id: "PETS_ALLOWED", name: "Haustierfreundlich" },
  { id: "NON_SMOKING", name: "Nichtraucherunterkunft" },
  { id: "BARRIER_FREE_ACCESS", name: "Barrierefreier Zugang" },
  { id: "SMOKE_DETECTOR", name: "Rauchmelder" },
  { id: "CARBON_MONOXIDE_DETECTOR", name: "Kohlenmonoxidmelder" },
  { id: "FIRST_AID_KIT", name: "Erste-Hilfe-Set" },
  { id: "FIRE_EXTINGUISHER", name: "Feuerlöscher" },
  { id: "ALARM_SYSTEM", name: "Alarmanlage" },
  { id: "OUTDOOR_SHOWER", name: "Außendusche" },
  { id: "SUN_LOUNGERS", name: "Liegestühle" },
  { id: "SUNSHADE", name: "Sonnenschirm" },
  { id: "GARDEN_FURNITURE", name: "Gartenmöbel" },
  { id: "SWING", name: "Schaukel" },
  { id: "SANDBOX", name: "Sandkasten" },
  { id: "TRAMPOLINE", name: "Trampolin" },
  { id: "TENNIS_COURT", name: "Tennisplatz" },
  { id: "GOLF_COURSE_NEARBY", name: "Golfplatz in der Nähe" },
  { id: "FISHING_POSSIBILITIES", name: "Angelmöglichkeiten" },
  { id: "HORSE_RIDING", name: "Reitmöglichkeit" },
  { id: "BOAT_DOCK", name: "Bootsanleger" },
  { id: "SKI_ROOM", name: "Skiraum" },
  { id: "SLED", name: "Schlitten" },
  { id: "SLEDDING_HILL_NEARBY", name: "Rodelbahn in der Nähe" },
  { id: "HIKING_TRAILS", name: "Wanderwege" },
  { id: "BIKE_TRAILS", name: "Radwege" },
  { id: "GROCERY_SERVICE_BEFORE_ARRIVAL", name: "Einkaufsservice vor Anreise" },
  { id: "WALLBOX", name: "Wallbox" },
  { id: "E_BIKE", name: "E-Bike" },
  { id: "BICYCLE", name: "Fahrrad" },
  { id: "IN_GREEN", name: "Im Grünen" },
  { id: "CITY_NEAR", name: "Stadtnah" },
  { id: "CLOSE_TO_LAKE", name: "Nähe zum See" },
  { id: "CLOSE_TO_SKI_SLOPE", name: "Nähe zur Skipiste" },
  { id: "LOCATION_ABOVE_1500_METERS", name: "Lage über 1.500 Meter" },
  { id: "LOCATION_ABOVE_2000_METERS", name: "Lage über 2.000 Meter" },
  { id: "SHOPPING_NEARBY", name: "Einkaufsmöglichkeiten in der Nähe" },
];
